import React from 'react';
import { FormGroup, Row, Col } from 'reactstrap';

import Text from '../../components/Text';

const styles = {
  smallText: {
    display: 'block',
    marginTop: '50px',
    marginBottom: '25px',
  },
  list: {
    paddingLeft: '25px',
  },
};

export default function PasswordRequirementsFormGroup() {
  return (
    <FormGroup>
      <Row>
        <Col>
          <small style={styles.smallText}>
            <Text value="Password heading" />
            <ul style={styles.list}>
              <li>
                <Text value="Uppercase Letter" />
              </li>
              <li>
                <Text value="Lowercase Letter" />
              </li>
              <li>
                <Text value="A Number" />
              </li>
              <li>
                <Text value="A Symbol" />
              </li>
            </ul>
          </small>
        </Col>
      </Row>
    </FormGroup>
  );
}
